var app = angular.module('leonardo');

var PercentFilter = function ($filter) {
  return function (input, decimals) {
    return $filter('number')(input * 100, decimals) + '%';
  };
};

app.filter('percent', ['$filter', PercentFilter]);
 